// extracted by mini-css-extract-plugin
export default {"app":"Capture_app__EDnGs","headerBar":"Capture_headerBar__6Aqce","view":"Capture_view__4O64l"};